import { render, staticRenderFns } from "./big_index.vue?vue&type=template&id=9d256a52&scoped=true"
import script from "./big_index.vue?vue&type=script&lang=js"
export * from "./big_index.vue?vue&type=script&lang=js"
import style0 from "./big_index.vue?vue&type=style&index=0&id=9d256a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d256a52",
  null
  
)

export default component.exports